import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

	//apiURL = 'http://interlaceindia.com/botdetect-captcha-lib';
	//apiURL = 'http://192.168.10.233/botdetect-captcha-lib';
	apiURL = 'https://ilmswebstag.interlaceindia.com:7000';
	//apiURL = 'http://localhost:8000';

	
	constructor(private http: HttpClient) { }
	
	// Http Options
	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json'
			//'Access-Control-Allow-Origin': '*'
		})
	}
	
	getCaptcha() {
	  return this.apiURL + '/simple-botdetect.php';
	}
	
	/* verifyCaptcha(captchaData : any): Observable<any> {
		return this.http.post<any>(this.apiURL + '/contact.php', JSON.stringify(captchaData), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	} */
	
	verifyCaptcha(captchaData : any): Observable<any> {
		return this.http.post<any>(this.apiURL + '/checkCaptcha/', JSON.stringify(captchaData), this.httpOptions)
		.pipe(
			retry(1),
			catchError(this.handleError)
		)
	}
	
	// Error handling 
	handleError(error : any) {
		let errorMessage = '';
		if(error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		window.alert(errorMessage);
		return throwError(errorMessage);
	}
}
